import styled from "styled-components";

export const CourseTitle = styled.h1`
  font-family: "DM Sans";
  font-size: 28px;
  font-weight: 700;
  line-height: 24.52px;
  text-align: left;
`;

export const CourseDescription = styled.p`
  font-family: "DM Sans";
  font-size: 18px;
  font-weight: 400;
  line-height: 24.52px;
  text-align: left;
`;

export const CourseTitleAndDescription = styled.div`
  display: flex;
  height: fit-content;
  /* flex-direction: column; */
  justify-content: space-between;
  :hover {
    border: 1px dashed lightgray;
    border-radius: 10px;
  }
`;

export const CourseFormInput = styled.input`
  width: 100%;
  font-family: "DM Sans";
  font-size: 28px;
  font-weight: 700;
  line-height: 19px;
  margin-bottom: 5px;
  min-height: calc(34px);
  border: none;
  border-bottom: 1px solid lightgray;
  padding: 5px 10px;
  color: black;
  &:focus {
    border: none;
    border-bottom: 1px solid lightgray;
    outline: none;
  }
`;

export const CourseFormTextArea = styled.textarea`
  width: 100%;
  font-family: "DM Sans";
  font-weight: 400;
  font-size: 18px;
  line-height: 19px;
  min-height: calc(34px);
  border: none;
  height: fit-content;
  border-bottom: 1px solid lightgray;
  padding: 5px 10px;
  color: black;
  resize: vertical;
  margin-bottom: 5px;
  &:focus {
    border: none;
    border-bottom: 1px solid lightgray;
    outline: none;
  }
`;

export const ErrorFeedback = styled.div`
  color: red;
  font-family: "DM Sans";
  font-weight: 400;
  font-size: calc(12px);
  line-height: 19px;
`;

export const ImgInput = styled.button`
  background: none;
  border: 0.5px dashed lightgray;
  width: 240px;
  height: calc(100%);
  min-height: 120px;
  border-radius: 6px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
